import { useEffect, useRef, useState } from 'react'
import SearchComponent from '../../../search'
import { searchVariantsOptions } from '../../../search/constants'
import { isEmpty } from 'lodash'
import ContextMenuComponent from '../../../../organisms/context-menu'
import {
  DropdownHeaderSearchContainer,
  NotFoundContainer,
  NotFoundText
} from '../../styled-components'

const MenuHeaderSearch = ({ options }) => {
  const [filteredOptions, setFilteredOptions] = useState(options)
  const [value, setValue] = useState('')
  const searchRef = useRef(null)

  useEffect(() => {
    if (value === '' || isEmpty(options)) {
      setFilteredOptions(options)
    } else {
      const filter = options?.filter(
        (item) =>
          item?.title.toLowerCase().includes(value.toLowerCase()) &&
          item?.title !== value
      )

      setFilteredOptions(filter)
    }
  }, [value, options])

  useEffect(() => {
    searchRef.current?.focus()
  }, [])

  if (!options) return null

  const Items = () => {
    if (isEmpty(filteredOptions)) {
      return (
        <NotFoundContainer>
          <NotFoundText>No result found</NotFoundText>
        </NotFoundContainer>
      )
    }
    return (
      <>
        {filteredOptions.map((option) => (
          <ContextMenuComponent.Item key={String(option.id)} {...option} />
        ))}
      </>
    )
  }

  return (
    <>
      <DropdownHeaderSearchContainer onClick={(e) => e.stopPropagation()}>
        <SearchComponent.Root
          variant={searchVariantsOptions.DESKTOP}
          customOnChange={(value) => setValue(value)}
          defaultDesktopVariantOpen={true}
          ref={searchRef}
        >
          <SearchComponent.Container>
            <SearchComponent.Input />
            <SearchComponent.ClearButton />
          </SearchComponent.Container>
          <SearchComponent.CancelButton />
        </SearchComponent.Root>
      </DropdownHeaderSearchContainer>
      {Items()}
    </>
  )
}

export default MenuHeaderSearch
